<template>
  <div class="work-order-real-time">
    <div class="table-container">
      <div class="table-header">
        <div class="header-cell index-col">{{ $t('序号') }}</div>
        <div class="header-cell">{{ $t('工单类型') }}</div>
        <div class="header-cell">{{ $t('紧急程度') }}</div>
        <div class="header-cell">{{ $t('联系人') }}</div>
        <div class="header-cell">{{ $t('联系电话') }}</div>
        <div class="header-cell">{{ $t('申请人') }}</div>
        <div class="header-cell">{{ $t('申请时间') }}</div>
        <div class="header-cell">{{ $t('来源') }}</div>
        <div class="header-cell">{{ $t('状态') }}</div>
      </div>
      
      <div class="table-body">
        <vue-seamless-scroll 
          :data="list" 
          class="seamless-warp" 
          ref="seamlessScroll" 
          :class-option="classOption">
          <ul class="list-ul">
            <li class="list-row" v-for="(item, index) in list" :key="index">
              <div class="list-order">
                <div class="order">{{ index + 1 }}</div>
              </div>
              <div class="list-item">{{ getTicketTypeName(item.ticketsType) }}</div>
              <div class="list-item" :style="{color:{0:'red','1':'orange','2':'yellow','3':'green'}[item.ticketsEmergency]}">
                {{ getUrgencyText(item.ticketsEmergency) }}
              </div>
              <div class="list-item">{{ item.ticketsContact || '-' }}</div>
              <div class="list-item">{{ item.ticketsContactPhone || '-' }}</div>
              <div class="list-item">{{ item.createBy || '-' }}</div>
              <div class="list-item">{{ formatTime(item.createTime) }}</div>
              <div class="list-item">{{ getSourceText(item.sourceType) }}</div>
              <div class="list-item">
                <div v-if="item.ticketsType == 0|| item.ticketsType == 2|| item.ticketsType == 3 || item.ticketsType == 4||item.ticketsType == 7||item.ticketsType == 8||item.ticketsType == 11">
                  <div v-if="item.ticketsState == -1" class="state0">
                    {{ $t('已结束') }}
                  </div>
                  <div v-else :class="'state'+item.ticketsState">
                    {{[$t('未开启'),$t('现场处理'),$t('审核'),$t('归档')][item.ticketsState]}}
                  </div>
                </div>
                <div v-if="item.ticketsType == 1||item.ticketsType == 5||item.ticketsType == 6">
                  <div v-if="item.ticketsState == -1" class="state0">
                    {{ $t('已结束') }}
                  </div>
                  <div v-else :class="'state'+item.ticketsState">
                    {{[$t('未开启'),$t('现场勘察'),$t('设计方案'),$t('预算'),$t('领导审批'),$t('财务缴费'),$t('现场施工'),$t('大厅复核'),$t('归档'),$t('关闭')][item.ticketsState]}}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: 'WorkOrderRealTime',
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      list: [],
      displayList: [],
      currentIndex: 0,
      pageSize: 10,
      isAnimating: false,
      url: {
        list: "/jeecg-engineering/ticket/tickets/list"
      },
      scrollInterval: null,
      errorCount: 0,
      classOption: {
        step: 0.5,
        limitMoveNum: 10,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1000
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.clearScrollInterval()
  },
  methods: {
    init() {
      this.resetData()
      this.getData()
    },
    resetData() {
      this.list = []
      this.displayList = []
      this.currentIndex = 0
      this.clearScrollInterval()
    },
    async getData() {
      try {
        const res = await getAction(this.url.list, { 
          workState: 0, 
          pageSize: 15,
          sort: 'createTime',
          order: 'desc'
        })
        
        if (res.success && res.result?.records) {
          this.list = res.result.records
          this.$nextTick(() => {
            if (this.$refs.seamlessScroll) {
              this.$refs.seamlessScroll.reset()
            }
          })
        } else {
          this.loadMockData()
        }
      } catch (error) {
        console.error('获取实时工单数据失败:', error)
        this.loadMockData()
      }
    },
    loadMockData() {
      const mockData = []
      const types = [0, 1, 2]
      const emergencies = [0, 1]
      const sources = [0, 1, 2]
      const statuses = {
        0: [-1, 0, 1, 2, 3, 4, 5],
        1: [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        2: [-1, 0, 1, 2, 3, 4]
      }
      
      for (let i = 0; i < 30; i++) {
        const type = types[Math.floor(Math.random() * types.length)]
        mockData.push({
          id: `WO${Date.now() + i}`,
          ticketsType: type,
          ticketsEmergency: emergencies[Math.floor(Math.random() * emergencies.length)],
          ticketsContact: `联系人${i + 1}`,
          ticketsContactPhone: `138${Math.floor(Math.random() * 90000000) + 10000000}`,
          createBy: `申请人${i + 1}`,
          createTime: new Date(Date.now() - Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
          sourceType: sources[Math.floor(Math.random() * sources.length)],
          ticketsState: statuses[type][Math.floor(Math.random() * statuses[type].length)]
        })
      }
      
      this.list = mockData
      this.startScrollAnimation()
    },
    startScrollAnimation() {
      this.updateDisplayList()
      this.scrollInterval = setInterval(() => {
        this.animateScroll()
      }, 3000)
    },
    animateScroll() {
      this.isAnimating = true
      
      setTimeout(() => {
        this.currentIndex = (this.currentIndex + 1) % Math.max(1, this.list.length - this.pageSize + 1)
        this.updateDisplayList()
        this.isAnimating = false
      }, 300)
    },
    updateDisplayList() {
      const start = this.currentIndex
      const end = Math.min(start + this.pageSize, this.list.length)
      this.displayList = this.list.slice(start, end)
      
      if (this.displayList.length < this.pageSize && this.list.length > this.pageSize) {
        const remaining = this.pageSize - this.displayList.length
        this.displayList = [...this.displayList, ...this.list.slice(0, remaining)]
      }
    },
    clearScrollInterval() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval)
        this.scrollInterval = null
      }
    },
    getTicketTypeName(type) {
      const types = {
        0: this.$t('换表'),
        1: this.$t('个人新装'),
        2: this.$t('故障报修'),
        3: this.$t('报停'),
        4: this.$t('复接'),
        5: this.$t('用水'),
        6: this.$t('企业新装'),
        7: this.$t('销户'),
        8: this.$t('用水性质变更'),
        11: this.$t('水厂报修')
      }
      return types[type] || '-'
    },
    getUrgencyText(emergency) {
      const emergencies = {
        0: this.$t('紧急'),
        1: this.$t('严重'),
        2: this.$t('一般'),
        3: this.$t('建议')
      }
      return emergencies[emergency] || '-'
    },
    getUrgencyClass(emergency) {
      return emergency === 0 ? 'normal' : 'urgent'
    },
    getSourceText(source) {
      const sources = {
        0: 'PC',
        1: this.$t('小程序'),
        2: this.$t('公众号'),
        undefined: 'PC',
        null: 'PC'
      }
      return sources[source] || '-'
    },
    getSourceClass(source) {
      const classes = {
        0: 'source-pc',
        1: 'source-mini',
        2: 'source-mp'
      }
      return classes[source] || 'source-default'
    },
    getStatusText(item) {
      if (item.ticketsState === -1) return this.$t('已结束')
      
      const statusMap = {
        0: {
          0: this.$t('未开启'),
          1: this.$t('换表登记'),
          2: this.$t('旧表审核'),
          3: this.$t('绑定新表'),
          4: this.$t('安装'),
          5: this.$t('审核工单')
        },
        1: {
          0: this.$t('未开启'),
          1: this.$t('报装申请'),
          2: this.$t('报装受理'),
          3: this.$t('报装勘察设计'),
          4: this.$t('报装预算'),
          5: this.$t('报装审批'),
          6: this.$t('报装收费'),
          7: this.$t('报装施工'),
          8: this.$t('报装验收'),
          9: this.$t('报装建档')
        },
        2: {
          1: this.$t('未开启'),
          2: this.$t('接单'),
          3: this.$t('处理'),
          4: this.$t('归档')
        }
      }
      
      const typeStatus = statusMap[item.ticketsType]
      return typeStatus ? (typeStatus[item.ticketsState] || '-') : '-'
    },
    getStatusClass(item) {
      if (item.ticketsState === -1) return 'status-ended'
      if (item.ticketsState === 0) return 'status-pending'
      return 'status-processing'
    },
    formatTime(time) {
      if (!time) return '-'
      var date = time.split(' ')
      var month = date[0].split('-')[1]+'-'+date[0].split('-')[2]
      var hM = date[1].split(':')[0]+':'+date[1].split(':')[1]
      return month+' '+hM
    }
  }
}
</script>

<style lang="less" scoped>
.work-order-real-time {
  height: 100%;
  padding: 0;
}

.table-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-header {
  display: flex;
  background: linear-gradient(135deg, rgba(8, 48, 111, 0.8) 0%, rgba(1, 32, 67, 0.6) 100%);
  border: 1px solid rgba(0, 170, 255, 0.3);
  border-radius: 4px 4px 0 0;
  height: 35px;
  align-items: center;
  padding: 0 5px;
}

.header-cell {
  color: #b6deff;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  
  &:not(.index-col) {
    flex: 1;
    min-width: 0;
  }
}

.index-col {
  width: 45px;
  flex-shrink: 0;
}

.table-body {
  flex: 1;
  overflow: hidden;
}

.list-ul {
  padding: 0;
  margin: 0;
}

.list-row {
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 0 5px;
  border-bottom: 1px solid rgba(0, 170, 255, 0.1);
  color: #b6deff;
  height: 32px;
  line-height: 32px;
  border: 1px solid #011a3a;
}

.list-order {
  width: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.order {
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #00a2f3 0%, #019af3 100%);
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 11px;
}

.list-item {
  flex: 1;
  color: #fff;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.seamless-warp {
  height: calc(100% - 35px);
  overflow: hidden;
}

.seamless-warp:hover {
  overflow-y: auto;
}

.seamless-warp::-webkit-scrollbar {
  width: 4px;
}

.seamless-warp::-webkit-scrollbar-track {
  background: #0e0c4f;
  border-radius: 2px;
}

.seamless-warp::-webkit-scrollbar-thumb {
  background: #292f88;
  border-radius: 2px;
}

.state0{
  color: #f5f5f5;
}
.state1{
  color: #4634FA;
}
.state2{
  color: #F6BB2F;
}
.state3{
  color: #50E3C2;
}
.state4{
  color: #32C5FF;
}
.state5{
  color: #0091FF;
}
.state6{
  color: #0394FF;
}
.state7{
  color: #0C2D82;
}
.state8{
  color: #B620E0;
}
.state9{
  color: #F7B500;
}
.state10{
  color: #FA6400;
}
.state11{
  color: #E02020;
}

@media (max-width: 1600px) {
  .header-cell {
    font-size: 11px;
  }
  
  .list-item {
    font-size: 11px;
  }
}

@media (max-width: 1200px) {
  .header-cell,
  .list-item {
    font-size: 10px;
  }
}
</style>